<form [formGroup]="formGroup">
  <section class="template-section">
    <h3 class="basic-flex-container">
      <mat-icon fontSet="material-icons-outlined">drive_file_rename_outline</mat-icon>
      File name
    </h3>
    <div>
      <input
        class="full-width"
        type="text"
        formControlName="sourceValue"
        placeholder="e.g. Formatted_CV"
        [matTooltip]="'The file name given to the generated document - excluding .docx'"
        matTooltipShowDelay="500"
        [matTooltipPosition]="'left'"
      />
      @if (sourceValue?.hasError('pattern')) {
        <div class="error-message">File name cannot start or end with a space</div>
      }
    </div>
  </section>
  <!--  {{ formGroup.value | json }}-->
</form>
